// extracted by mini-css-extract-plugin
export default {"cross_timer":"_34WOMWuq6IQLVcgR46eCHu"};